import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { ReactComponent as Icon } from "../../media/icons/404.svg";
import styles from "./errorBoundary.module.css";

const ErrorBoundaryComponent = () => {
  const { t } = useTranslation();
  const lastError = useSelector(state => state.requestTracking.lastError);

  const handleCopyReferenceId = useCallback(() => {
    if (!lastError?.requestId) {
      return;
    }

    navigator.clipboard.writeText(lastError.requestId).catch(() => {});
  }, [lastError?.requestId]);

  return (
    <div className={styles.main}>
      <div className={styles.imgWrap}>
        <Icon className={styles.errorImg} />
      </div>
      <p className={styles.textError}>
        {t("dashboard_errorboundary_title")} <br /> {t("dashboard_errorboundary_subtitle")}
      </p>
      {lastError?.requestId ? (
        <div className={styles.referenceIdWrap}>
          <p className={styles.referenceIdLabel}>{t("dashboard_common_load_error_reference_id")}</p>
          <div className={styles.referenceIdRow}>
            <code className={styles.referenceIdValue}>{lastError.requestId}</code>
            <button type="button" className={styles.referenceIdCopy} onClick={handleCopyReferenceId}>
              {t("dashboard_common_button_copy")}
            </button>
          </div>
        </div>
      ) : null}
      <a className={styles.button} href="/">
        {t("dashboard_errorboundary_home")}
      </a>
    </div>
  );
};

export default ErrorBoundaryComponent;
